import BasePage from "../../../../base/BasePage";
// import {NavBar} from "nq-component";
import NavBar from "../../../../components/navigation";
import React from "react";
import EmplopyeeInfoPresenter from "./EmplopyeeInfoPresenter";
import { Button } from "nq-component";
import browseFile from "../../../../browseFile";
import { addSchemaUseCase } from "../../../../usecases/schema/usecases";
import CardView from "../../../../components/common/CardView";
import RegionTab from "../../../../components/common/RegionTab";
import RecognitionMeritPage from "./EmployeeInfoTable/RecognitionMerit/RecognitionMeritPage";
import RequestsPage from "./EmployeeInfoTable/Requests/RequestsPage";

class EmployeeInfoPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new EmplopyeeInfoPresenter(this, addSchemaUseCase());
    this.state = { progress: false };
  }

  showProgress() {
    this.setState({ progress: true });
  }

  hideProgress() {
    this.setState({ progress: false });
  }

  render() {
    const tabs = [
      {
        title: "Recognitions / Merit",
        content: (
          <div>
            <RecognitionMeritPage employee={this.props.employee} />
          </div>
        ),
      },
      {
        title: "Requests",
        content: (
          <div>
            <RequestsPage />
          </div>
        ),
      },
    ];
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="row m-auto w-100 h-100 mb-2 "
          style={{ height: "300px" }}
        >
          <div className="col-lg-12 mb-3 ">
            <RegionTab tabs={tabs} tabContents={tabContents} />
          </div>
        </div>
      </>
    );
  }
}

export default EmployeeInfoPage;
